import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserConnectQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
}>;


export type GetCurrentUserConnectQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly isWizardFinished: boolean, readonly roles: ReadonlyArray<Types.AccountsUserRole>, readonly company?: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly uuid: string, readonly name: string, readonly tokens: ReadonlyArray<{ readonly __typename?: 'OauthProviderToken', readonly lastError?: string | null, readonly provider: Types.OauthProvider, readonly accounts: ReadonlyArray<{ readonly __typename?: 'YalperAccount', readonly id: string, readonly name: string }> }> } | null } | null };

export type GetCurrentUserHelpQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrentUserHelpQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly phone?: string | null, readonly profile?: { readonly __typename?: 'AccountsProfile', readonly id: string, readonly name?: string | null } | null } | null };


export const GetCurrentUserConnectDocument = gql`
    query GetCurrentUserConnect($companyId: ID!) {
  currentUser {
    isWizardFinished
    roles
    company(id: $companyId) {
      id
      uuid
      name
      tokens {
        lastError
        provider
        accounts {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserConnectQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserConnectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserConnectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserConnectQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCurrentUserConnectQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserConnectQueryPage, GetCurrentUserConnectQueryVariables> & ({ variables: GetCurrentUserConnectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserConnectQueryPage, GetCurrentUserConnectQueryVariables>(GetCurrentUserConnectDocument, options);
      }
export function useGetCurrentUserConnectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserConnectQueryPage, GetCurrentUserConnectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserConnectQueryPage, GetCurrentUserConnectQueryVariables>(GetCurrentUserConnectDocument, options);
        }
export function useGetCurrentUserConnectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserConnectQueryPage, GetCurrentUserConnectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserConnectQueryPage, GetCurrentUserConnectQueryVariables>(GetCurrentUserConnectDocument, options);
        }
export type GetCurrentUserConnectQueryHookResult = ReturnType<typeof useGetCurrentUserConnectQuery>;
export type GetCurrentUserConnectLazyQueryHookResult = ReturnType<typeof useGetCurrentUserConnectLazyQuery>;
export type GetCurrentUserConnectSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserConnectSuspenseQuery>;
export type GetCurrentUserConnectQueryResult = Apollo.QueryResult<GetCurrentUserConnectQueryPage, GetCurrentUserConnectQueryVariables>;
export const GetCurrentUserHelpDocument = gql`
    query GetCurrentUserHelp {
  currentUser {
    phone
    profile {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCurrentUserHelpQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserHelpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserHelpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserHelpQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserHelpQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserHelpQueryPage, GetCurrentUserHelpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserHelpQueryPage, GetCurrentUserHelpQueryVariables>(GetCurrentUserHelpDocument, options);
      }
export function useGetCurrentUserHelpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserHelpQueryPage, GetCurrentUserHelpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserHelpQueryPage, GetCurrentUserHelpQueryVariables>(GetCurrentUserHelpDocument, options);
        }
export function useGetCurrentUserHelpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserHelpQueryPage, GetCurrentUserHelpQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserHelpQueryPage, GetCurrentUserHelpQueryVariables>(GetCurrentUserHelpDocument, options);
        }
export type GetCurrentUserHelpQueryHookResult = ReturnType<typeof useGetCurrentUserHelpQuery>;
export type GetCurrentUserHelpLazyQueryHookResult = ReturnType<typeof useGetCurrentUserHelpLazyQuery>;
export type GetCurrentUserHelpSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserHelpSuspenseQuery>;
export type GetCurrentUserHelpQueryResult = Apollo.QueryResult<GetCurrentUserHelpQueryPage, GetCurrentUserHelpQueryVariables>;